import "./Styles/styles.css";

export const TotalMoney = ({ setListTransactions }) => {
  return (
    <div className="total-value-container">
      <div className="total-value-discription">
        <h1>Valor Total:</h1>
        <p>O valor se refere ao saldo</p>
      </div>
      <div className="total-value">
        <h2>{() => setListTransactions()}</h2>
      </div>
    </div>
  );
};
